import { Input, TableCell, TableRow } from '@mui/material'
import React from 'react'
import { toEuroString } from '../../../common/utils'
import { MonthlyTarget } from './incentiveProductTypes'

interface MonthlyTargetsRowProps {
  months: number[]
  monthlyTargetFormData: MonthlyTarget[]
  isEditing: boolean
  changeMonthlyTarget: (month: number, value: number) => void
}

function findMonthlyTarget(monthlyTargets: MonthlyTarget[], month: number): MonthlyTarget | undefined {
  return monthlyTargets.find((mt) => mt.month === month)
}

export default function MonthlyTargetsRow({
  months,
  monthlyTargetFormData,
  isEditing,
  changeMonthlyTarget,
}: MonthlyTargetsRowProps) {
  const currentMonth = new Date().getMonth() + 1
  const currentYear = new Date().getFullYear()
  return (
    <TableRow>
      {months.map((month) => {
        const monthlyTarget = findMonthlyTarget(monthlyTargetFormData as Array<any>, month)
        const isCurrentMonth = month === currentMonth && monthlyTarget?.year === currentYear
        if (!monthlyTarget) {
          return <TableCell key={month}>-</TableCell>
        }
        return isEditing && !isCurrentMonth ? (
          <TableCell key={month}>
            <Input
              size='small'
              type='number'
              value={monthlyTarget.incentiveSalesTarget}
              onChange={(event) => changeMonthlyTarget(monthlyTarget.month, Number(event.target.value))}
              sx={{
                fontSize: '0.75rem',
              }}
            />
          </TableCell>
        ) : (
          <TableCell key={month}>{monthlyTarget ? toEuroString(monthlyTarget.incentiveSalesTarget) : '-'}</TableCell>
        )
      })}
    </TableRow>
  )
}
